import {Injectable} from "@angular/core";
import {HttpService} from '../../_service/http.service';
import {UserPoll} from "../../main-page/poll-part/poll-models/user-poll-model";
import {WebResult, WebResultGeneric} from "../../shared-module/models/web-result";
import {PaymentData} from "./models/payment-data";
import {PaymentUserData, PaymentUserDataAdapter} from "./models/payment-user-data";
import {PaymentDeviceType} from "./models/payment-device-type";
import {PaymentOption} from "./models/payment-option";
import {WidgetSaldo} from "../../main-page/account-part/widget-saldo";
@Injectable()
export class PaySaldoService {
  constructor(private httpService: HttpService,
              private paymentUserDataAdapter: PaymentUserDataAdapter) {
  }

  public async getSaldoDto(accountNumber, addressId, number, alias) {

    const sb = [];
    sb.push('rest/getAccountState?');
    sb.push('&accountNumber=' + accountNumber.toString());
    sb.push('&addressId=' + addressId);
    sb.push('&apartmentNumber=' + number.toString());
    sb.push('&organizationAlias=' + alias);

    return this.httpService.getData(sb.join(''));
  }

  public async getSaldoDtoOnSite(accountNumber, realtyId, blockId?: string): Promise<WidgetSaldo> {

    const sb = [];
    sb.push('rest/getAccountStateByUser?');
    sb.push('&accountNumber=' + accountNumber.toString());
    sb.push('&realtyId=' + realtyId);

    return this.httpService.getDataWithLocalAuth(sb.join(''), blockId);
  }

  public async postUserPayment(paymentUserData: PaymentUserData,
                               blockId: string = null): Promise<PaymentData> {
    const sb = [];
    sb.push('rest/');
    sb.push('postUserPayment');

    const paymentData = this.paymentUserDataAdapter.adaptOut(paymentUserData);

    return this.httpService.postDataWithAuth(sb.join(''), paymentData, blockId)
        .then((result: WebResultGeneric<PaymentData>) => {
              return result.data;
            },
            (error) => {
              throw error;
            });
  }


  public async getPaymentOptions(accountVerCommonId: string,
                                 deviceType: PaymentDeviceType,
                                blockId: string = null): Promise<Array<PaymentOption>> {

    const sb = [];
    sb.push('rest/');
    sb.push('getPaymentOptions?');
    sb.push('accountVerCommonId=');
    sb.push(accountVerCommonId);
    sb.push('&deviceType=');
    sb.push(deviceType);

    return this.httpService.getDataWithLocalAuth(sb.join(''), blockId)
        .then((result: Array<PaymentOption>) => {
              return result;
            },
            (error) => {
              throw error;
            });
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/pay-saldo.service.ts